/* unplugin-vue-components disabled */import { render } from "./MfButton.vue?vue&type=template&id=0aeb78ae&scoped=true"
import script from "./MfButton.vue?vue&type=script&lang=js"
export * from "./MfButton.vue?vue&type=script&lang=js"

import "./MfButton.vue?vue&type=style&index=0&id=0aeb78ae&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aeb78ae"]])

export default __exports__